/**
 * Domain configuration for the marketing / product split.
 *
 *   hostea.io      -> marketing website only
 *   app.hostea.io  -> product (dashboard, check-in, guestbook, owner portal, staff)
 *
 * On localhost and Vercel previews everything keeps running on a single host:
 * APP_URL falls back to the current origin and the DomainGuard stays inactive.
 */

// Absolute base URL used when generating product links (check-in, guestbook, QR codes...)
export const APP_URL =
  process.env.REACT_APP_APP_URL ||
  (/(^|\.)hostea\.io$/.test(window.location.hostname)
    ? 'https://app.hostea.io'
    : window.location.origin);

export const MARKETING_URL = 'https://hostea.io';

// Path prefixes served by the marketing website on hostea.io ('/' is handled as
// an exact match). IMPORTANT: any new marketing route added in AppRouter.jsx
// MUST be listed here, otherwise the DomainGuard will redirect it to app.hostea.io.
export const MARKETING_PREFIXES = [
  '/about',
  '/pricing',
  '/solutions',
  '/contact',
  '/cookie-policy',
  '/privacy',
  '/terms',
  '/signup', // alias that immediately redirects to /contact
];

// Marketing pages matched exactly — their sub-paths stay on the app
// (e.g. /integrations/igloohome is the partner page, /integrations/igloohome/callback the OAuth return).
export const MARKETING_EXACT_PATHS = ['/integrations/igloohome'];

export const isMarketingPath = (pathname) =>
  pathname === '/' ||
  MARKETING_EXACT_PATHS.includes(pathname.replace(/\/+$/, '')) ||
  MARKETING_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
